// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pvxukd0 {
  margin-left: -16px;
  margin-right: -16px;
}
@media screen and (min-width: 768px) {
  .pvxukd0 {
    margin-left: 0;
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".pvxukd0 {\n  margin-left: -16px;\n  margin-right: -16px;\n}\n@media screen and (min-width: 768px) {\n  .pvxukd0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
